module.exports = __webpack_public_path__ + "img/logos.b17d497f.png";